import { createFileRoute } from "@tanstack/react-router";
import { DeptContentList } from "@/components/dept-content/DeptContentList";
import { CURRICULUM } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/curriculum/")({
  component: () => <DeptContentList cfg={CURRICULUM} />,
});
